import { useContext } from "react";
import { useSelector } from "react-redux";
import { TranslationContext } from "../../../context/TranslationContext";
import { TranslationContextInterface } from "../../../entities/Language";
import { getValueForKey } from "../../../context/translationsUtils";
import { getDataFromMixture } from "../../Mixture/selectors";
import { CheckoutInfoStyled } from "./CheckoutInfoStyled";
import { MixtureChooseEnum } from "../../../entities/Mixture";

const CheckoutInfo: React.FC = () => {
  const { translations }: TranslationContextInterface =
    useContext(TranslationContext);
  const { condiments, totalParts, mixtureOption } =
    useSelector(getDataFromMixture);
  return (
    <CheckoutInfoStyled>
      <span>
        {getValueForKey(translations, "nav_bar.nav_card_mix_ingredients")}
      </span>
      <span>
        {condiments.length}{" "}
        {getValueForKey(translations, "edit_mix.ingredients")}
      </span>
      {mixtureOption === MixtureChooseEnum.PARTS && (
        <span>
          {totalParts} {getValueForKey(translations, "edit_mix.parts_hint")}
        </span>
      )}
    </CheckoutInfoStyled>
  );
};

export default CheckoutInfo;
